import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import IDeviceResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/device-response-dto";
import { EDateTypes } from "../../../shared/oversight-core/enums/date-types";
import { RootState } from "../../store";

interface IMeterDashboardFilters {
  selectedDate: Date;
  selectedDateType: EDateTypes;
}

const defaultFilters: IMeterDashboardFilters & IDeviceResponseDTO = {
  deviceId: "",
  vendorId: "",
  firstSeenAt: "",
  lastSeenAt: "",
  selectedDate: new Date(),
  selectedDateType: EDateTypes.DAILY,
};

export const meterSlice = createSlice({
  name: "meter",
  initialState: { ...defaultFilters },
  reducers: {
    setSelectedMeterDevice: (
      state,
      action: PayloadAction<IDeviceResponseDTO>,
    ) => {
      state.deviceId = action.payload.deviceId;
      state.vendorId = action.payload.vendorId;
      state.firstSeenAt = action.payload.firstSeenAt;
      state.lastSeenAt = action.payload.lastSeenAt;
    },
    setMeterDashboardFilters: (
      state,
      action: PayloadAction<IMeterDashboardFilters>,
    ) => {
      state.selectedDate = action.payload.selectedDate;
      state.selectedDateType = action.payload.selectedDateType;
    },
  },
});

export const { setSelectedMeterDevice, setMeterDashboardFilters } =
  meterSlice.actions;

export const selectMeterDevice = (state: RootState) => state.meter;
export const selectMeterDashboardFilters = (state: RootState) => state.meter;

export default meterSlice.reducer;
